export default {
    DOCUMENT_TYPE: "DOCUMENT_TYPE",
    CATEGORY: "CATEGORY",
    METADATA: "METADATA",
    NOTE: "NOTE",
    FULL_TEXT: "FULL_TEXT",
    DOC_ATTR: "DOCUMENT_ATTRIBUTES",
    FILE_ATTR: "FILE_ATTRIBUTES",
    DOC_VAR: "DOCUMENT_VARIABLES",
    HIDDEN: "HIDDEN",
    CUSTOM: "OTHER",
    FILE_TYPE: "FILE_TYPE",
    // ui only
    LINKED_SQL_OUTPUT: "LINKED_SQL_OUTPUT",
    // ui only
    LINKED_REST_OUTPUT: "LINKED_REST_OUTPUT"
};
